import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";

export default function ReceptionOMC() {
  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title reception__title">
        График работы врачей консультативно-диагностического отделения в рамках
        территориальной программы ОМС 2025 год
      </h1>

      <table className="contacts__table first_table">
        <tbody>
          {/* <tr className="contacts__line"> */}
          {/* <th className="contacts__caption" colSpan={7}>
            Мужская венерология
          </th> */}
          {/* </tr> */}
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">Врач</td>
            <td className="contacts__cell second_cell">Кабинет</td>
            <td className="contacts__cell second_cell">Понедельник</td>
            <td className="contacts__cell second_cell">Вторник</td>
            <td className="contacts__cell second_cell">Среда</td>
            <td className="contacts__cell second_cell">Четверг</td>
            <td className="contacts__cell second_cell">Пятница</td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Кокорина Наталья Станиславовна<br></br>К.М.Н.*
            </td>
            <td className="contacts__cell second_cell">305</td>
            <td className="contacts__cell second_cell">13:00 – 15:30</td>
            <td className="contacts__cell second_cell">13:00 – 15:30</td>
            <td className="contacts__cell second_cell">13:00 – 15:30</td>
            <td className="contacts__cell second_cell">09:30 - 11:30</td>
            <td className="contacts__cell second_cell">13:00 – 15:00</td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Фарленкова Елена Юрьевна <br></br>
              Высшая категория
            </td>
            <td className="contacts__cell second_cell">7</td>
            <td className="contacts__cell second_cell">09:00 - 11:00</td>
            <td className="contacts__cell second_cell">11:00 - 13:00</td>
            <td className="contacts__cell second_cell">13:00 - 15:00</td>
            <td className="contacts__cell second_cell">11:00 - 13:00</td>
            <td className="contacts__cell second_cell">11:00 - 13:00</td>
          </tr>
          <tr className="contacts__line">
            <td className="contacts__cell second_cell">
              Рабцевич Виталия Владимировна<br></br>Высшая категория
            </td>
            <td className="contacts__cell second_cell">6</td>
            <td className="contacts__cell second_cell">11:00 - 13:00</td>
            <td className="contacts__cell second_cell">09:00 - 11:00</td>
            <td className="contacts__cell second_cell">11:00 - 13:00</td>
            <td className="contacts__cell second_cell">13:00 - 15:00</td>
            <td className="contacts__cell second_cell">09:00 - 11:00</td>
          </tr>
        </tbody>
      </table>
      <p className="dissertation__text">К.М.Н - Кандидат медицинских наук</p>
    </section>
  );
}
